import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './infographic-page-bluebox.component.scss';
var InfographicPageBluebox = /** @class */ (function (_super) {
    tslib_1.__extends(InfographicPageBluebox, _super);
    function InfographicPageBluebox(element) {
        return _super.call(this, element) || this;
    }
    InfographicPageBluebox.prototype.init = function () { };
    InfographicPageBluebox.prototype.bindEvents = function () { };
    return InfographicPageBluebox;
}(Base));
export { InfographicPageBluebox };



//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-bluebox/infographic-page-bluebox.component.ts
// module id = 384
// module chunks = 0